import { useState } from "react";
import { NinjaArt } from "../art/NinjaArt";
import { PinPad } from "../components/PinPad";
import { RANKS } from "../content/ranks";
import { progressFor, type LocalChild } from "../save/store";
import "./WhosPlaying.css";

interface Props {
  kids: LocalChild[];
  onChoose: (id: string) => void;
  /** Shown when switching from Home, so a child can go back. */
  onBack?: (() => void) | undefined;
}

/** A child's highest rank across every strand, for their card. */
export function topRank(c: LocalChild): number {
  return Math.max(...Object.values(progressFor(c).rank));
}

export function WhosPlaying({ kids, onChoose, onBack }: Props) {
  const [pinFor, setPinFor] = useState<LocalChild | null>(null);

  if (pinFor?.pin)
    return (
      <section className="screen whos">
        <PinPad
          title={`${pinFor.name}, tap your three ninjas`}
          expected={pinFor.pin}
          onDone={() => onChoose(pinFor.id)}
          onCancel={() => setPinFor(null)}
        />
      </section>
    );

  return (
    <section className="screen whos">
      <h1 className="display whos-title">Who&apos;s playing?</h1>
      <ul className="whos-list">
        {kids.map((c) => {
          const rank = RANKS[topRank(c)]!;
          return (
            <li key={c.id}>
              <button
                type="button"
                className="whos-card"
                style={{ "--c": rank.colour } as React.CSSProperties}
                onClick={() => (c.pin ? setPinFor(c) : onChoose(c.id))}
              >
                <NinjaArt rank={rank} className="whos-art" />
                <span className="display whos-name">{c.name || "Ninja"}</span>
                <span className="whos-rank">{rank.name}</span>
              </button>
            </li>
          );
        })}
      </ul>
      {onBack && (
        <button type="button" className="ghost whos-back" onClick={onBack}>
          Back
        </button>
      )}
    </section>
  );
}
